const chartsScriptUrl = 'https://www.gstatic.com/charts/loader.js'

let chartsLoaderPromise = null

export function getChartsLoader () {
	// If already included in the page:
	if (window.google && window.google.charts) {
		return Promise.resolve(window.google.charts)
	}
	if (!chartsLoaderPromise) {
		chartsLoaderPromise = new Promise(resolve => {
			const script = document.createElement('script')
			script.type = 'text/javascript'
			script.onload = () => resolve(window.google.charts)
			script.src = chartsScriptUrl
			document.body.appendChild(script)
		})
	}
	return chartsLoaderPromise
}

export default function loadGoogleCharts () {
	return getChartsLoader().then(loader => {
		const loaderPromise = new Promise(resolve => {
			loader.load('current', { packages: ['corechart'] })
			loader.setOnLoadCallback(() => resolve(window.google))
		})
		return loaderPromise
	})
}
